module.exports = __webpack_public_path__ + "img/4.c5dcf74e.jpg";